import Collection from 'core/model/Collection';
import moment from 'moment';
import CdnModel from './CdnModel';

class CdnCollection extends Collection {
  get url() {
    return '/api/ui/cdn';
  }

  get model() {
    return CdnModel;
  }

  get defaultSortState() {
    return {
      field: 'name',
      direction: 'asc'
    };
  }

  get filterFieldWhitelist() {
    return new Set(['id', 'name']);
  }

  get lastCdnUpdate() {
    return this.get().reduce((d, i) => Math.max(d, moment(i.get('edate')).valueOf()), 0);
  }

  findByName(name) {
    return this.get().find((item) => item.get('name') === name);
  }
}

export default CdnCollection;
